

























































import PartnerReportDialog from "@/components/partner/PartnerReportCreateDialog.vue";
import PartnerReportDetail from "@/components/partner/PartnerReportDetail.vue";
import PartnerReportInitializeDialog from "@/components/partner/PartnerReportInitializeDialog.vue";
import PartnerReportList from "@/components/partner/PartnerReportList.vue";
import PartnerReportListPaginated from "@/components/partner/PartnerReportListPaginated.vue";
import PartnerReportDetailV2, { ReportTabs } from "@/components/partner/report/v2/PartnerReportDetail.vue";
import TheLayoutPortalSplit from "@/layouts/TheLayoutPortalSplit.vue";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { handleError } from "@/lib/utility/handleError";
import { ReportGoToHelper } from "@/lib/utility/report.go-to-helper";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { IReport, Report } from "@/models/report.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";
import { ActivityLogModule } from "@/store/modules/activity-log.store";
import { ExportModule } from "@/store/modules/export.store";
import { FeatureModule } from "@/store/modules/feature.store";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { RefsMessagesModule } from "@/store/modules/refs.store";
import { ReportModule } from "@/store/modules/report.store";
import { ThirdPartySystemModule } from "@/store/modules/third-party-system.store";
import { mixins } from "vue-class-component";
import { Component, Ref } from "vue-property-decorator";

@Component({
  components: {
    TheLayoutPortalSplit,
    PartnerReportList,
    PartnerReportDetail,
    PartnerReportDetailV2,
    PartnerReportListPaginated,
    PartnerReportInitializeDialog,
    PartnerReportDialog
  }
})
export default class PartnerReports extends mixins(PartnerFallbackMixin, PermissionMixin) {
  loading = false;

  @Ref("reportDetail")
  readonly reportDetail?: PartnerReportDetailV2;

  get svg() {
    return require("@/assets/undraw/undraw_meditation_re_gll0.svg");
  }

  get partnerId() {
    return PartnerModule.partner._id;
  }

  get isReportV2() {
    return FeatureModule.isReportV2 || PartnerModule.partner.partnerType === PartnerTypeEnum.BROKER;
  }

  get report() {
    return PartnerModule.report;
  }

  get partner() {
    return PartnerModule.partner ?? ReportModule.partner;
  }

  get isBroker() {
    return this.partner.partnerType === PartnerTypeEnum.BROKER;
  }

  async mounted() {
    PartnerModule.setReport(null);
    await this.trySetByRouteOrDefault();

    const reportId = this.$route.query.reportId as string;
    if (reportId) {
      const report = new Report({ partnerId: this.partnerId, id: reportId });

      await this.loadDetail(report);
    }
  }

  async loadDetail(report: IReport) {
    this.$log.debug(`PartnerReports.loadDetail: ${report?._id}`);

    if (this.$vuetify.breakpoint.smAndDown) {
      await this.$router.push({
        name: "PartnerReportsDetailView",
        params: { reportId: report.id, partnerId: report.partnerId }
      });

      return;
    } else {
      new ReportGoToHelper(this.$router).setUrl(
        ReportGoToHelper.locations.reportList({
          partnerId: this.partnerId,
          query: report ? { reportId: report.id } : {}
        })
      );
    }

    this.$log.debug(`Start Loading PartnerReports.loadDetail: ${report?._id}`);

    try {
      this.loading = true;
      const promises: Promise<any>[] = [];

      promises.push(
        PartnerModule.getReportByPartnerIdAndReportId({ documentId: report.id, partnerId: report.partnerId })
      );

      ActivityLogModule.setFilters([
        new PageFilterElement({
          key: "source.refId",
          operation: PageFilterOperationEnum.EQUAL,
          value: report.id
        })
      ]);
      promises.push(ActivityLogModule.fetchFirstPage({ partnerId: report.partnerId }));

      if (FeatureModule.isTpsActive && UserModule.abilities.can(ActionEnum.READ, ResourceEnum.TPS, report.partnerId)) {
        ThirdPartySystemModule.setFilters([
          new PageFilterElement({
            key: "refs.refId",
            operation: PageFilterOperationEnum.EQUAL,
            value: report.id
          })
        ]);
        promises.push(
          ThirdPartySystemModule.fetchFirstPage({ partnerId: report.partnerId }).catch(error => this.$log.error(error))
        );
      } else {
        promises.push(
          ExportModule.getExportReportMetaByPartnerIdAndReportId({
            partnerId: report.partnerId,
            reportId: report.id
          }).catch(error => this.$log.error(error))
        );
      }

      if (PartnerModule.partner.partnerType !== PartnerTypeEnum.BROKER) {
        RefsMessagesModule.generateFrontendTimeLineElementsForMessagesAssociatedWithReference({
          refId: report.id,
          partnerId: report.partnerId
        });
      }

      await Promise.all(promises);

      if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.VEHICLE, PartnerModule.report.partnerId)) {
        if (this.report) {
          await this.report.fetchVehicle();

          if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.FLEET, PartnerModule.report.partnerId)) {
            if (this.report.vehicle) {
              await this.report.vehicle?.fetchFleet();
            }
          }
        }
      }
    } catch (e) {
      handleError(e);
    } finally {
      this.loading = false;
    }
  }

  async set(item: IReport) {
    await this.loadDetail(item);

    this.reportDetail?.setTab(ReportTabs.DAMAGE);
  }
}
